import { cva as t, ct as o } from "@/styled-system/css";
const r = t({
  base: {},
  variants: {
    tone: {
      brand: {
        color: o("TextButton.colors.brand.icon.default")
      },
      neutral: {
        color: o("TextButton.colors.neutral.icon.default")
      },
      subtle: {
        color: o("TextButton.colors.subtle.icon.default")
      }
    },
    onImpact: {
      true: {
        color: o("TextButton.colors.onImpact.icon.default")
      },
      false: {}
    },
    disabled: {
      true: {},
      false: {}
    },
    size: {
      sm: {},
      md: {}
    }
  },
  compoundVariants: [
    {
      tone: "brand",
      disabled: !1,
      css: {
        color: {
          _groupHover: o("TextButton.colors.brand.icon.hover"),
          _groupActive: o("TextButton.colors.brand.icon.pressed")
        }
      }
    },
    {
      tone: "neutral",
      disabled: !1,
      css: {
        color: {
          _groupHover: o("TextButton.colors.neutral.icon.hover"),
          _groupActive: o("TextButton.colors.neutral.icon.pressed")
        }
      }
    },
    {
      tone: "subtle",
      disabled: !1,
      css: {
        color: {
          _groupHover: o("TextButton.colors.subtle.icon.hover"),
          _groupActive: o("TextButton.colors.subtle.icon.pressed")
        }
      }
    },
    {
      onImpact: !0,
      disabled: !1,
      css: {
        color: {
          _groupHover: o("TextButton.colors.onImpact.icon.hover"),
          _groupActive: o("TextButton.colors.onImpact.icon.pressed")
        }
      }
    }
  ]
});
export {
  r as textButtonIconRecipe
};
//# sourceMappingURL=text-button-icon.styles.js.map
